var React = require('react');

function CentreMapInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 2v16.356L1 22V5.646zm14 0v16.356L15 22V5.646zM8 2v16.356L15 22V5.646z","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

CentreMapInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CentreMapInline;

CentreMapInline.default = CentreMapInline;
